export const SHORT_RANGE_DISTANCE_THRESHOLD = 2
export const RECALCULATE_ROUTE_EVERY_X_KM = 0.5
export const STROKE_COLOR = '#0165FF'
